import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    guoZhao: null,
 };

export const guoZhaoSlice = createSlice({
    name: 'guoZhao',
    initialState,
    reducers: {
        setGuoZhao(state, action) {
            state.guoZhao = action.payload;
        },
    }
});

export default guoZhaoSlice;